<div class="payment-option-container" (click)="$event.stopPropagation()">
  <form [formGroup]="paymentFormGroup">
    <mat-radio-group
      class="payment-radio"
      formControlName="paymentType"
      >
      <div class="payment-radio__btn">
        <mat-radio-button
          [value]="paymentOptionFullPrice"
          [checked]="paymentTypeVal == paymentOptionFullPrice && paymentOptionFPTypeVal == paymentOptionRazer"
          class="fp-margin"
          (change)="fpRazerSelected($event)"
          >
          <div class="payment-radio__label">Credit/Debit</div>
          <div class="payment-radio__bold">
            RM {{ this.totalPriceBeforeCharges | number : "1.2-2" }}
          </div>
          @if (paymentTypeVal != paymentOptionFullPrice || paymentOptionFPTypeVal == paymentOptionShopee) {
            <div>
              <img src="/assets/icons/payments/full-price.png" alt="" class="payment-radio__btn__icon">
            </div>
          }
        </mat-radio-button>
        @if (paymentTypeVal == paymentOptionFullPrice && paymentOptionFPTypeVal == paymentOptionRazer) {
          <mat-radio-group
            class="payment-radio full-price"
            formControlName="paymentChannel"
            >
            <div class="ml-lg mb-sm mt-md">{{ "paymentOptions.paymentMethod" | translate }}</div>
            <mat-radio-button [checked]="true" [value]="paymentOptionVisa">
              <div>
                Visa / Mastercard
              </div>
              <img src="/assets/icons/payments/full-price-1.png" alt="" class="full-price__icon">
            </mat-radio-button>
            <mat-radio-button [checked]="false"  [value]="paymentOptionFpx">
              <div>
                Online Banking (FPX)
              </div>
              <img src="/assets/icons/payments/full-price-2.png" alt="" class="full-price__icon">
            </mat-radio-button>
            <!-- @if (allowEwallet) {
              <mat-radio-button [checked]="false"  [value]="paymentOptionEwallet">
                <div>
                  e-Wallet
                </div>
                <img src="/assets/icons/payments/full-price-3.png" alt="" class="full-price__icon">
              </mat-radio-button> -->
            <!-- } -->
            @if (paymentChannelVal == paymentOptionEwallet) {
              <mat-form-field  class="e-wallet-form">
                <mat-label>{{ "paymentOptions.selectEWallet" | translate }}</mat-label>
                <mat-select
                  disableOptionCentering
                  required
                  formControlName="ewalletType"
                  >
                  @for (item of ewalletTypeListing; track item) {
                    <mat-option
                      [value]="item?.value"
                      >
                      <span class="ewallet-options">
                        <img [src]="item?.img" alt="">
                        {{ item?.name }}
                      </span>
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </mat-radio-group>
        }
      </div>
      <!-- Atome BNPL -->
      @if (!onlyFullPayment) {
        <mat-radio-button
          class="payment-radio__btn"
          [value]="paymentOptionBNPL"
          [checked]="paymentChannelVal == paymentOptionAtome">
          <div class="payment-radio__label">{{ "common.atome" | translate }}</div>
          <div class="mt-xs">
            <span>
              <div
                class="payment-radio__label"
                [innerHTML]="'common.atomeBNPL' | translate"
              ></div>
            </span>
          </div>
          <div>
            <img
              src="/assets/icons/payments/AtomeBNPL.png"
              alt=""
              class="payment-radio__btn__icon"
              />
            </div>
          </mat-radio-button>
        }
        @if (!onlyFullPayment) {
          <mat-radio-button
            [value]="paymentOptionFullPrice"
            [checked]="paymentTypeVal == paymentOptionFullPrice && paymentOptionFPTypeVal == paymentOptionShopee"
            class="payment-radio__btn"
            (change)="fpShopeeSelected($event)"
            >
            <div class="payment-radio__label">SPayLater / ShopeePay</div>
            <div class="mt-xs">
              <span><b>
                {{ "paymentOptions.ScanQRAndChooseInstalmentsUp" | translate }}
                {{ "paymentOptions.to12Months" | translate }}.
              </b></span>
              <div class="mt-sm">
                <img
                  src="/assets/icons/spaylater_spay.png"
                  alt=""
                  class="shopee-icon"
                  />
                </div>
              </div>
              <!-- <div class="payment-radio__shopee-copy"> -->
            <!-- </div> -->
          </mat-radio-button>
        }
        <!-- Shopback : hidden on production only) -->
        @if (showShopback && !onlyFullPayment) {
          <mat-radio-button
            [value]="paymentOptionShopback"
            [checked]="paymentTypeVal == paymentOptionShopback"
            class="payment-radio__btn"
            >
            <div class="payment-radio__label">{{ "common.shopback" | translate }}</div>
            <div class="mt-xs payment-radio__bold">
              <span>RM {{ this.totalPriceBeforeCharges | number : "1.2-2" }}</span>
            </div>
            <div class="payment-radio__shopback-copy">
              <span class="bold">{{ "common.shopbackPay" | translate }}&nbsp;</span>
              {{ "common.shopbackGet" | translate }}&nbsp;
              <span class="shopback-orange"> {{ "common.shopbackCashback" | translate }}</span>
              <img src="/assets/icons/payments/shopback.png" alt=""  class="shopback-icon" />
            </div>
          </mat-radio-button>
        }
        @if (showEPP3Or6Or12Months && !onlyFullPayment) {
          <mat-radio-button
            [value]="paymentOptionEPP"
            [checked]="this.paymentFormGroup?.value?.paymentOptionEPPType == paymentOptionEPP3Or6Or12Months"
            class="payment-radio__btn"
            (change)="epp3Or6Or12MonthsSelected($event)"
            >
            <div class="payment-radio__label">{{ "paymentOptions.eppDuration" | translate }}</div>
            <div class="mt-xs">
              <span>{{ "paymentOptions.epp" | translate }}</span>
              <span class="gap"></span>
              <img src="/assets/icons/payments/rms.png" alt=""  class="payment-radio__btn__icon" />
            </div>
            <img src="/assets/icons/payments/visa-mastercard.png" alt=""  class="payment-radio__btn__icon" />
            @if (this.paymentFormGroup?.value?.paymentOptionEPPType == paymentOptionEPP3Or6Or12Months) {
              <div class="payment-radio__btn__epp">
                <mat-form-field >
                  <mat-label>{{ "paymentOptions.cardIssuer" | translate }}</mat-label>
                  <mat-select
                    disableOptionCentering
                    formControlName="bank"
                    (selectionChange)="eppBankSelected($event.value)"
                    >
                    @for (item of epp3Or6Or12MonthsChargeDistinctList; track item) {
                      <mat-option
                        [value]="item?.bankName"
                        class="epp-options"
                        >
                        <span class="ewallet-options">
                          <img [src]="item?.bankLogoUrl" alt="">
                          {{ item?.bankName }}
                        </span>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                @if (this.paymentFormGroup?.value?.bank) {
                  <mat-form-field >
                    <mat-label>{{ "paymentOptions.monthlyOption" | translate }}</mat-label>
                    <mat-select
                      disableOptionCentering
                      formControlName="installmentMonth"
                      >
                      @for (item of filterListBasedOnSelectedBanks(epp3Or6Or12MonthsChargeList); track item) {
                        <mat-option
                          [value]="item?.installmentPeriod"
                          class="epp-options"
                          >
                          {{ getPaymentMonthLabel(item.installmentPeriod) | translate }}
                          (<span class="epp-options__bold">
                          RM {{ getTotalPriceInstallment(item.installmentPeriod) | number : "1.2-2" }}
                        </span>
                        {{ "common.perMonth" | translate }})
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </div>
          }
        </mat-radio-button>
      }
      @if (showEPP6Or12Months && !onlyFullPayment) {
        <mat-radio-button
          [value]="paymentOptionEPP"
          [checked]="this.paymentFormGroup?.value?.paymentOptionEPPType == paymentOptionEPP6Or12Months"
          class="payment-radio__btn"
          (change)="epp6or12MonthsSelected($event)"
          >
          <div class="payment-radio__label">{{ "paymentOptions.6or12months" | translate }}</div>
          <div class="mt-xs">
            <span>{{ "paymentOptions.epp" | translate }}</span>
            <span class="gap"></span>
            <img src="/assets/icons/payments/payex.png" alt=""  class="payment-radio__btn__icon" />
          </div>
          <img src="/assets/icons/payments/visa-mastercard.png" alt=""  class="payment-radio__btn__icon" />
          @if (this.paymentFormGroup?.value?.paymentOptionEPPType == paymentOptionEPP6Or12Months) {
            <div class="payment-radio__btn__epp">
              <mat-form-field >
                <mat-label>{{ "paymentOptions.cardIssuer" | translate }}</mat-label>
                <mat-select
                  disableOptionCentering
                  formControlName="bank"
                  (selectionChange)="eppBankSelected($event.value)"
                  >
                  @for (item of epp6Or12MonthsChargeDistinctList; track item) {
                    <mat-option
                      [value]="item?.bankName"
                      class="epp-options"
                      >
                      <span class="ewallet-options">
                        <img [src]="item?.bankLogoUrl" alt="">
                        {{ item?.bankName }}
                      </span>
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (this.paymentFormGroup?.value?.bank) {
                <mat-form-field >
                  <mat-label>{{ "paymentOptions.monthlyOption" | translate }}</mat-label>
                  <mat-select
                    disableOptionCentering
                    formControlName="installmentMonth"
                    >
                    @for (item of filterListBasedOnSelectedBanks(epp6Or12MonthsChargeList); track item) {
                      <mat-option
                        [value]="item?.installmentPeriod"
                        class="epp-options"
                        >
                        {{ getPaymentMonthLabel(item.installmentPeriod) | translate }}
                        (<span class="epp-options__bold">
                        RM {{ getTotalPriceInstallment(item.installmentPeriod) | number : "1.2-2" }}
                      </span>
                      {{ "common.perMonth" | translate }})
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </div>
        }
      </mat-radio-button>
    }

  </mat-radio-group>
</form>
</div>